function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useGiveUpControl, useSessionLock } from "@hooks";
import React, { useEffect } from "react";
import { connect } from "react-redux";
var mapStateToProps = function(param) {
    var videoPlayer = param.videoPlayer, liveChannels = param.liveChannels, filteredLiveChannels = param.filteredLiveChannels, profileSettings = param.profileSettings;
    return {
        videoPlayer: videoPlayer,
        liveChannels: liveChannels,
        filteredLiveChannels: filteredLiveChannels,
        profileSettings: profileSettings
    };
};
var withSessionLock = function(Component) {
    var SessionLock = function(props) {
        var videoPlayer = props.videoPlayer, timeToLockChannels = props.timeToLockChannels, lockPeriod = props.lockPeriod, filteredLiveChannels = props.filteredLiveChannels, liveChannels = props.liveChannels, rest = _object_without_properties(props, [
            "videoPlayer",
            "timeToLockChannels",
            "lockPeriod",
            "filteredLiveChannels",
            "liveChannels"
        ]);
        // Unknown state yet.
        // -1 means the channel are locked based on 'timeToLockChannels'
        var _useSessionLock = _sliced_to_array(useSessionLock(), 2), locked = _useSessionLock[0], _useSessionLock_ = _useSessionLock[1], unlock = _useSessionLock_.unlock, giveUpControl = _useSessionLock_.giveUpControl;
        // When videoPlayer is opened reset 'locked'
        // status back to be controlled by the 'timeToLockChannels' field
        useGiveUpControl(props, giveUpControl);
        return /*#__PURE__*/ _jsx(Component, _object_spread({
            locked: locked,
            unlock: unlock
        }, props));
    };
    return connect(mapStateToProps, null)(SessionLock);
};
export default withSessionLock;
